import { DEVICE_PIXEL_THRESHOLD, } from "@bracket/ui/const";
import type { DeviceType } from "@bracket/ui/types";

export declare type GetDeviceTypeOptions = {
	/** The user agent string to check for mobile indicators */
	userAgent?: string;
	/** The window width to check against mobile breakpoint */
	windowWidth?: number;
	/** The mobile breakpoint width in pixels (default: 768) */
	mobileBreakpoint?: number;
};

/**
 * Evaluates the browser or display and returns the device type.
 * Checks both user agent strings and window width to determine if the device is mobile.
 * 
 * @param options - The options for device type detection
 * @param options.userAgent - The user agent string to check for mobile indicators
 * @param options.windowWidth - The window width to check against mobile breakpoint
 * @param options.mobileBreakpoint - The mobile breakpoint width in pixels (default: 768)
 * @returns "MOBILE" for mobile phones, "DEVICE" otherwise
 */
export const getDeviceType = ({ 
	userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "",
	windowWidth = typeof window !== "undefined" ? window.innerWidth : 1920,
	mobileBreakpoint = DEVICE_PIXEL_THRESHOLD
}: GetDeviceTypeOptions = {}): DeviceType => {
	
	// Check user agent for mobile indicators
	const mobileUserAgentRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
	const isMobileUserAgent = mobileUserAgentRegex.test(userAgent);
	
	// Check window width
	const isMobileWidth = windowWidth < mobileBreakpoint;
	
	// Return MOBILE if either condition is true
	if (isMobileUserAgent || isMobileWidth) {
		return "MOBILE";
	}
	
	return "DEVICE";
};
